<template>
  <nav class="fullTable-pagination">
    <ul class="fullTable-pagination-list">
      <li v-if="current != 1" class="pager cursor-pointer"><a @click="skipPages(-5)">‹‹</a></li>
      <li v-if="current != 1" class="pager cursor-pointer"><a @click="skipPages(-1)">‹</a></li>
      <li v-for="(
            item,
            index
          ) of rango" :id="index + 1" :key="index" class="cursor-pointer" :class="getClasses(item, current)">
        <a @click="changedPage(item)">{{ item }}</a>
      </li>
      <li v-if="current != total" class="pager cursor-pointer"><a @click="skipPages(1)">›</a></li>
      <li v-if="current != total" class="pager cursor-pointer"><a @click="skipPages(5)">››</a></li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    color: {
      type: String,
      default: "success",
    },
    size: {
      type: String,
      default: "md",
    },
    total: {
      type: Number,
      default: 1
    },
    current: {
      type: Number,
      default: 1,
    },

  },
  emits: ['changed-page'],
  computed: {
    rango() {
      let ret = [];
      let start = 0;
      let items = 5;
      if (this.total < items) {
        items = this.total;
      }
      if (this.current - 3 > 0) {
        start = this.current - 3;
      }
      if (this.current + 3 > this.total) {
        start = this.total - items;
      }
      for (let index = start; index < start + items; index++) {
        ret.push(index + 1);
      }
      return ret;
    }
  },
  methods: {
    changedPage(index) {
      this.$emit('changed-page', index);
    },
    skipPages(pages) {
      let toPage = this.current + pages;
      if (toPage <= 0) {
        toPage = 1;
      }
      if (toPage > this.total) {
        toPage = this.total;
      }

      this.changedPage(toPage);
    },
    getClasses(index, current) {
      return index === current ? "active" : "";
    },
  },
};
</script>
